import React from "react";
import StayTouch from "../../layout/StayTouch";
import AnyQuestions from "../../reusable/AnyQuestions";
import TopBanner from "../../reusable/ActiveDeviceBanner";
import ActiveDeviceRequestController from "./ActiveDeviceRequestController";
import ActiveSubNavi from "./ActiveSubNavi";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import { connect } from "react-redux";

class ActiveDevice extends React.Component {
    render(){
        const { isAuthenticated, user } = this.props.auth;
        return(
            <div>
                <TopBanner title="Activate Device" />
                {/*<ActiveSubNavi />*/}
                <ActiveDeviceRequestController isAuthenticated={isAuthenticated} user={user} />
                <AnyQuestions />
                <StayTouch />
            </div>
        );
    }
}

function mapStateToProps(state) {
    if(!state.auth.isAuthenticated) {
        state.auth.redirect = "/activate";
    }
    return {
        auth: state.auth
    };
}
export default connect(mapStateToProps)(layoutWrapper(ActiveDevice));



// WEBPACK FOOTER //
// ./src/pages/ActiveDevice/index.js